import React, { useEffect, useState } from 'react';
import { useApi } from '../../services/ApiServices.tsx'; // Servicio para hacer las solicitudes a la API
import Header from '../../components/Header.tsx';
import Footer from '../../components/Footer.tsx';
import Grid2 from '@mui/material/Grid2/Grid2';
import './Tips.css';
import { TipsPrincipales } from '../../interfaces/TipsPrincipales.interface.ts';
import { Typography } from '@mui/material';
import TipComponent from './TipComponent.tsx';

function Recetas() {
  const { ApiRequest } = useApi();
  const [isLoadingTips, setIsLoadingTips] = useState(true);
  const [tips, setTips] = useState<TipsPrincipales[]>([]);

  useEffect(() => {
    const fetchTips = async () => {
      try {
        setIsLoadingTips(true);
        const data = await ApiRequest('api/Tips/ObtenerTodosTips');
        setTips(data || []);
      } catch (error) {
        console.error('Error fetching baners:', error);
      } finally {
        setIsLoadingTips(false);
      }
    };

    fetchTips();
  }, [ApiRequest]);

  return (
    <Grid2>
      <Header />
        <Grid2 container >
            <Grid2 size={12}>
              <Grid2 className="tips-header">
                <Typography className="tips-header-title">Tips</Typography>
                <Typography className="tips-header-subtitle">Todos Nuestros tips</Typography>
                <Typography className="tips-header-description">Aquí encontrarás una colección de consejos prácticos y creativos para mejorar tu día a día. Desde trucos de cocina y organización hasta sugerencias para el bienestar y la eficiencia, nuestros tips están diseñados para hacer tu vida más fácil y agradable. ¡Explora, experimenta y disfruta de todas las ideas que tenemos para ti!</Typography>
              </Grid2>
              {tips && tips.length > 0 && (
                <div className="tips-container">
                  {tips.map((tip) => (
                    <TipComponent tip={tip} />
                  ))}
                </div>  
              )}
            </Grid2>
          </Grid2>
      <Footer />
    </Grid2>
  );
}

export default Recetas;
